export default [{"url":"https://prepasa-0.api.invexerp.io","name":"Branch 1","port":"6529","isStore":true,"isHQ":true}]